import { endpoint } from "../../../../../views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const fetchDepositedSlipsMock = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          id: "DEP001",
          bu: "JP001",
          cashier: "JP001",
          bankName: "HDFC",
          depositSlipId: "DP/CSH/JP001/1023",
          slipFileKey: "s3://bucket/deposit001.pdf",
          cashierId: "A12345 Mitesh Agarwal",
          receiptCount: 20,
          ackId: "1234567890",
          ackDate: "12/12/2025",
          updatedOn: "12/12/2025 at 11:30 PM by AESL-A123456",
          approvedOn: "12/12/2025 at 11:30 PM by AESL-A123456",
          amountCollected: 125000,
          status: "Not deposited",
        },
        {
          id: "DEP002",
          bu: "JP002",
          cashier: "JP002",
          bankName: "HDFC",
          depositSlipId: "DP/CSH/JP002/1024",
          slipFileKey: "s3://bucket/deposit002.pdf",
          cashierId: "A12345 Mitesh Agarwal",
          receiptCount: 20,
          ackId: "1234567890",
          ackDate: "12/12/2025",
          updatedOn: "12/12/2025 at 11:30 PM by AESL-A123456",
          approvedOn: "12/12/2025 at 11:30 PM by AESL-A123456",
          amountCollected: 125000,
          status: "In progress",
        },
      ]);
    }, 500);
  });
};

export const getDepositedListApi = (requestPayload, businessAreaId) => {
  const { pageNo, pageSize } = requestPayload;
  const request = { ...requestPayload, businessArea: businessAreaId };
  const url = `${endpoint.cashManagement.cashDashboard.depositedList}?offset=${pageNo}&pageSize=${pageSize}`;
  return fetchAllPostPromisedData(url, request, "POST");
};
